import { useStore } from '../store'

const PLANS = [
  { name: 'Free', price: '0đ', feats: ['Ghép & cắt không giới hạn', 'Phiên âm AI cục bộ', 'Xuất có logo BrandCut'] },
  { name: 'Pro', price: '199k/th', feats: ['Không watermark', 'Style DNA + đa nền tảng', 'Auto highlights', 'Studio audio'], hot: true },
  { name: 'Team', price: '499k/th', feats: ['Mọi thứ của Pro', 'Nhiều Style DNA / thương hiệu', 'Chia sẻ dự án', 'Hỗ trợ ưu tiên'] },
]

/** GĐ8 — About + bảng giá (demo). */
export function AboutModal() {
  const show = useStore((s) => s.showAbout)
  const setShow = useStore((s) => s.setShowAbout)
  if (!show) return null

  return (
    <div className="overlay" onClick={() => setShow(false)}>
      <div className="modal wide" onClick={(e) => e.stopPropagation()}>
        <h2>🎬 BrandCut</h2>
        <p className="muted">
          AI video editor học phong cách của chính bạn. Local-first — video của bạn không rời khỏi máy.
        </p>
        <div className="plans">
          {PLANS.map((p) => (
            <div key={p.name} className={`plan ${p.hot ? 'hot' : ''}`}>
              {p.hot && <div className="plan-badge">Phổ biến</div>}
              <div className="plan-name">{p.name}</div>
              <div className="plan-price">{p.price}</div>
              <ul>
                {p.feats.map((f) => (
                  <li key={f}>✓ {f}</li>
                ))}
              </ul>
            </div>
          ))}
        </div>
        <p className="muted" style={{ fontSize: 11 }}>
          * Bảng giá minh họa cho bản demo. Thanh toán chưa kích hoạt.
        </p>
        <button className="btn primary" onClick={() => setShow(false)}>Đóng</button>
      </div>
    </div>
  )
}
